<template>
  <label class="text-sm font-medium text-gray-700">
    <slot></slot>
  </label>
</template>

<script>
export default {};
</script>

<style></style>
